import { render, staticRenderFns } from "./NewLevelbar.vue?vue&type=template&id=2f2518ed&scoped=true&"
import script from "./NewLevelbar.vue?vue&type=script&lang=js&"
export * from "./NewLevelbar.vue?vue&type=script&lang=js&"
import style0 from "./NewLevelbar.vue?vue&type=style&index=0&id=2f2518ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2518ed",
  null
  
)

export default component.exports